import { useEffect, useState } from "react";
import logoLoading from "../../assets/bola.png";
import Style from "./style.module.css";

const Loading = ({ className = "", sizeIcono = "100px", sizeLoad = "120px", font = "30px" }) => {
  const [dots, setDots] = useState(".");

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDots((prev) => (prev === "..." ? "." : prev + "."));
    }, 400);

    return () => clearInterval(intervalId);
  }, []);
  return (
    <div className={` p-5 ${className}`} style={{ minHeight: "" }}>
      <div className={Style.loadingContainer} style={{ width: sizeLoad, height: sizeLoad }}>
        <div className={`${Style.animatedLogo}`}></div>
        <img
          className={Style.loadingImage}
          src={logoLoading}
          alt="loading-ico"
          style={{ width: sizeIcono, height: sizeIcono }}
        />
      </div>
      {/* <div className=" mx-auto" style={{ width: "140px" }}> */}
      <div className=" mx-auto">
        {/* <h2 className="text-center mt-3 mx-auto " style={{fontSize:font}}>Cargando{dots}</h2> */}
        <h2 className={`text-center mt-3 mx-auto ${Style.textLoading}`} style={{ fontSize: font }}>
          Cargando
        </h2>
      </div>
    </div>
  );
};
export default Loading;
